import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';

class ConfirmButton extends Component {
  state = { isOpen: false };
  action = null;
  lastEvent = null;

  showModal = (isOpen) => this.setState({ isOpen });

  handleOpen = (e) => {
    if (e && e.persist) e.persist(); 
    this.lastEvent = e;
    this.showModal(true);
  };

  executeAction = () => {
    this.showModal(false);
    if (typeof this.action === 'function') this.action(this.lastEvent);
    this.lastEvent = null;
  };

  render() {
    const { onClick, body, action, cancel, color, children, ...rest } = this.props;
    this.action = onClick;

    return (
      <>
        <Button 
            {...rest} color={color || 'danger'} 
            onClick={this.handleOpen}>
          {children}
        </Button>
        <Modal centered isOpen={this.state.isOpen}>
          <ModalBody>
            {body != null ? body : 'Are you sure you wish to proceed?'}
          </ModalBody>
          <ModalFooter>
            <Button color={color || 'danger'} onClick={this.executeAction}>
              {action != null ? action : 'Yes'}
            </Button>
            <Button onClick={() => this.showModal(false)}>
              {cancel != null ? cancel : 'Cancel'}
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default ConfirmButton;